module.exports = __webpack_public_path__ + "img/access-enterprise-app.c8f450dc.svg";